var AdaptiveImage = require("../node_modules/react-native-web-image-loader/lib/modules/adaptiveImage.js").default;

module.exports = new AdaptiveImage({
    uri: __webpack_public_path__ + "icon-mobile-phone.407a328b.png","uri@2x": __webpack_public_path__ + "icon-mobile-phone.b7a59568.png","uri@3x": __webpack_public_path__ + "icon-mobile-phone.74ef7428.png",
    width: 13,
    height: 22
});